'use strict';

export default function NavigationCtrl (
  $window,
  $rootScope,
  $scope,
  $element,
  $state,
  logout,
  join,
  modal,
  userModel,
  mobileNavigationMenu,
  breakpoint,
  guideStatus,
  unreadConversationIds,
  guideSearchFilters,
  navigation,
  deviceCapabilities,
  dashboard,
  becomeGuide,
  currencyOptions,
  // conversations,
  conversationsFetching,
  settings,
  currencyModel
) {
  'ngInject';

  navigation.setNavigationElement($element.children().eq(0));

  this.settings = settings;

  this.showJoinModal = join.showModal;
  this.logout = logout;
  this.userModel = userModel;
  this.guideStatus = guideStatus;
  this.unreadConversationIds = unreadConversationIds.getIds();
  this.guideSearchFilters = guideSearchFilters;
  this.isHoverEnabled = !deviceCapabilities.isIOSDevice;
  this.dashboard = dashboard;
  this.currencies = currencyOptions;
  this.currency = currencyModel.getValue();

  $scope.filters = this.guideSearchFilters.filters;

  if (userModel.itemPromise) {
    this.isLoading = true;
    userModel.itemPromise
      .finally(() => {
        delete this.isLoading;
      });
  }

  this.showMobileNavigationMenu = function () {
    mobileNavigationMenu.show();
  };

  this.search = function () {
    if (this.guideSearchFilters.filters.location) {
      this.guideSearchFilters.filters.location.idlist = null;
      this.guideSearchFilters.getParametrizedFilters().then((params) => {
        $state.go('guides.list', params);
      });
    }
  };

  this.becomeGuide = becomeGuide;

  this.openConversations = () => {
    if (!conversationsFetching.isFetching) {
      $state.go('conversations.list', {}, { reload: true });
    }
  };

  const LOCAL_LISTING_URL = 'guides.list';
  $rootScope.$on('userModel:initialized', () => {
    this.currency = currencyModel.getValue();
    if (guideStatus.isGuide() && !guideStatus.isUnverifiedGuide() && userModel.item.isDashboardEnabled) {
      dashboard.fetch();
    }
    $rootScope.$on('$stateChangeSuccess', (_, toState) => {
      if (toState.name === LOCAL_LISTING_URL && guideStatus.isUnverifiedGuide()) {
        // We know this is not a good solution
        // TODO: in the future do something better
        this.settings.fetch().then(() => {
          if (this.settings.progress != 100) {
            this.displaySettingsBar = true;
          }
          this.settings.getValidFieldCount();
        });
      }
    });
  });


}



// WEBPACK FOOTER //
// ./app/src/common/navigation/navigation.controller.js